<template>
  <a-card :bordered='false' class='formula-manage main_box' size='small'>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="公式类型" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-radio-group v-model="queryParam.type" @change="searchQuery">
                <a-radio-button value="1">
                  量表计算
                </a-radio-button>
                <a-radio-button value="2">
                  数据填入
                </a-radio-button>
                <a-radio-button value="3">
                  级联计算
                </a-radio-button>
                <a-radio-button value="4">
                  周期计算
                </a-radio-button>
                <!--<a-radio-button value="4">-->
                  <!--测评结果-->
                <!--</a-radio-button>-->
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="8" style="text-align: left">
            <a-button icon='plus' type='primary' @click='handleAdd()'  style="margin-left: 8px">新增</a-button>
            <a-button icon='plus' type='primary' @click='handleAddExist()'  style="margin-left: 8px">复制已有</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>
      <a-table :columns='columns'
               :dataSource='dataSource'
               :loading='loading'
               :pagination='ipagination'
               rowKey='id'
               size='small'
               @change='handleTableChange'>
        <span slot='action' slot-scope='text, record'>
          <!--<a-button size='small' type='primary' @click='handleStop(record.id , record.status==="1"?"0":"1")'>{{record.status==='1'?'停用':'启用'}}</a-button>-->
          <!--<a-divider type='vertical' />-->
          <a-button size='small' type='primary' @click='handleEditBase(record)'>编辑</a-button>
           <a-divider type='vertical' />
           <a-button size='small' type='primary' @click='handleEdit(record)'>配置</a-button>
            <a-divider type='vertical' />
          <a-popconfirm title='确定删除吗?' @confirm='() => handleDelete(record.id)'>
            <a-button size='small' type='danger'>删除</a-button>
          </a-popconfirm>
          <a-popconfirm v-has="'formula:reCalculate'" v-if="queryParam.type== 1 || queryParam.type== 2 || queryParam.type== 3" title='确定要重新计算该公式的所有受试者表单吗?' @confirm='() => reCalculate(record.id)'>
            <a-divider type='vertical' />
            <a-button size='small' type='warn'>重新计算</a-button>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <formula-model ref="modalForm" @ok="modalFormOk" :projectId="projectId"></formula-model>
    <a-modal
      title="公式查看"
      :width="1000"
      :visible="visible"
      @cancel="viewHandleCancel"
      :footer="null">
      <a-textarea :rows="4" v-model="currentFormula"></a-textarea>
    </a-modal>
    <a-modal
      title="编辑"
      :width="600"
      :visible="baseVisible"
      @cancel="baseHandleCancel"
      @ok="baseHandleOk">

      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form" layout="horizontal" :model="currentRecord" v-bind="{labelCol: { span: 3 },wrapperCol: { span: 21 },}" >
          <a-form-model-item  label='排序' prop='sortNum' >
            <a-input-number v-model="currentRecord.sortNum" placeholder="请输入排序" :min="0" :precision="0" style="width: 100px"/>
          </a-form-model-item>
          <a-form-model-item label='结论统计' prop='isConclusionStatistics' >
            <a-switch checkedChildren="是" unCheckedChildren="否" v-model="isConclusionStatistics"/>            
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
    <add-exist ref="addExist" @handleSelect="addExistSelect" :type="queryParam.type"></add-exist>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import FormulaModel from '@views/project/setting/formula/FormulaModel'
import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
import { getAction,postAction } from '@/api/manage'
import Vue from 'vue'
import AddExist from './formula/addexist/AddExist'
export default {
  name: 'Formula',
  components: { AddExist,  FormulaModel },
  mixins: [JeecgListMixin],
  data() {
    return {
      url: {
        list: '/project/projectFormula/list',
        delete: '/project/projectFormula/delete',
      },
      projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
      disableMixinCreated: true,
      currentFormula:'',
      visible:false,
      queryParam:{type:'1'},
      currentRecord:{},
      confirmLoading:false,
      baseVisible:false,
      isConclusionStatistics:false,
    }
  },
  computed: {
    columns() {
      const dynamicColumns = [
        {
          title: '排序',
          dataIndex: 'sortNum',
          align: 'center',
          width: 80,
        },
        {
          title: '公式更新表单',
          dataIndex: 'formName',
          width: 300,
          ellipsis: true
        },
        {
          title: '表单说明',
          width:"150",
          ellipsis: true,
          dataIndex: 'formDes'
        },
        {
          title: '公式更新字段',
          width: 300,
          dataIndex: 'formItemName',
          ellipsis: true
        },
        {
          title: '公式描述',
          dataIndex: 'description',
          ellipsis: true
        },
        // {
        //   title: '状态',
        //   dataIndex: 'status_dictText',
        //   width: 100,
        //   ellipsis: true
        // },
        {
          title: '公式类型',
          width: 100,
          dataIndex: 'type',
          ellipsis: true,
          customRender(text){
            let result = '量表计算'
            if(text==='2'){
              result = '数据填入'
            }else if(text==='3'){
              result = '级联填入'
            }else if(text==='4'){
              result = '周期计算'
            }
            return result
          },
        },
        {
          title: '操作',
          width: 300,
          scopedSlots: { customRender: 'action' },
          /*customRender: (text, record) => (
            <span>
              <a-button size='small' type='primary' onClick={event => this.handleStop(record)}>停用</a-button>
              <a-divider type='vertical' />
              <a-button size='small' type='danger' onClick={event => this.handleDelete(record.id)}>删除</a-button>
            </span>)*/
        }
      ];
      if (this.queryParam.type === '4'){
        dynamicColumns[1].title = '公式更新周期'
      }
      return dynamicColumns
    }
  },
  created() {
    this.baseQueryParam = {projectId:this.projectId}
    this.loadData()
  },

  methods: {
    baseHandleOk(){      
      postAction('/project/projectFormula/edit',{
        id:this.currentRecord.id,
        sortNum:this.currentRecord.sortNum,
        isConclusionStatistics: this.isConclusionStatistics
      }).then(res=>{
        if(res.success){
          this.baseHandleCancel()
          this.loadData()
        }
      })
    },
    baseHandleCancel(){
      this.currentRecord = {}
      this.baseVisible=false
      this.isConclusionStatistics=false
    },
    handleEditBase(record){
      this.currentRecord = Object.assign({},record)
      if(this.currentRecord.flag && (this.currentRecord.flag & 1)===1) {
        this.isConclusionStatistics = true
      }else{
        this.isConclusionStatistics = false
      }
      this.baseVisible=true
    },
    handleAddExist(){
      this.$refs.addExist.open()
    },
    addExistSelect(record){
      postAction('/project/projectFormula/copyByExist',{
        projectId:this.projectId,
        existId:record.id
      }).then(res=>{
        if(res.success){
          this.$message.success(res.message)
          this.loadData()
        }else{
          this.$message.error(res.message)
        }
      })
    },
    reCalculate(id){
      getAction('/project/projectFormula/calculate',{id: id }).then(res=>{
        if(res.success){
          this.$message.success(res.result)
        }else{
          this.$message.error(res.message)
        }
      })
    },
    /**
     * 停用
     */
    handleStop(id,status) {
      postAction('/project/projectFormula/editStatus',{id:id,status:status}).then(res=>{
        if(res.success){
          this.loadData()
        }
      })
    },
    handleView(record){
      this.currentFormula = record.formula
      this.visible = true
    },
    viewHandleCancel(){
      this.visible = false
    }
  }


}
</script>

<style lang='less' scoped>
@import '~@/assets/less/common.less';

/deep/ .ant-table-thead > tr > th,
/deep/ .ant-table-tbody > tr > td {
  line-height: 24px;
  padding: 6px 8px;
}
</style>
